define(["exports", "react", "moment", "react-intl-universal", "styled-components", "../../atoms/Typography", "../../atoms"], function (_exports, _react, _moment, _reactIntlUniversal, _styledComponents, _Typography, _atoms) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _moment = _interopRequireDefault(_moment);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var CourseItem = _styledComponents.default.div.withConfig({
    displayName: "Courses__CourseItem",
    componentId: "sc-pfzfop-0"
  })(["display:flex;width:100%;+ div{padding:32px 0 0;}"]);

  var IconBuilding = _styledComponents.default.span.withConfig({
    displayName: "Courses__IconBuilding",
    componentId: "sc-pfzfop-1"
  })(["background:", ";border:solid 1px ", ";padding:15px;margin-right:16px;max-height:56px;box-icon{display:block;fill:", ";}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.lightGray;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.dark;
  });

  var CourseName = (0, _styledComponents.default)(_Typography.H3).withConfig({
    displayName: "Courses__CourseName",
    componentId: "sc-pfzfop-2"
  })(["font-weight:", ";margin:0;"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.semibold;
  });
  var CourseSchool = (0, _styledComponents.default)(_Typography.Small).withConfig({
    displayName: "Courses__CourseSchool",
    componentId: "sc-pfzfop-3"
  })(["display:inline-block;line-height:24px;margin:0 0 8px;padding:0;width:100%;"]);
  var CourseDate = (0, _styledComponents.default)(_Typography.Small).withConfig({
    displayName: "Courses__CourseDate",
    componentId: "sc-pfzfop-4"
  })(["font-weight:", ";margin:0;padding:0 0 0 24px;position:relative;@media print{font-weight:", ";}box-icon{fill:", ";height:16px;left:0;position:absolute;top:2px;width:16px;}span{font-weight:", ";@media print{font-weight:", ";}}"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.font.semibold;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.font.bold;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.dark;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.font.regular;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.font.bold;
  });
  var TitleBox = (0, _styledComponents.default)(_Typography.H2).withConfig({
    displayName: "Courses__TitleBox",
    componentId: "sc-pfzfop-5"
  })(["margin:0 0 16px;"]);

  var Courses = function Courses(_ref10) {
    var courses = _ref10.courses;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TitleBox, null, _reactIntlUniversal.default.get('CURRICULUM.CURSOS_COMPLEMENTARES.TITULO')), courses.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(CourseItem, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(IconBuilding, null, /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "graduation",
        type: "solid"
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(CourseName, null, item.curso), /*#__PURE__*/_react.default.createElement(CourseSchool, null, item.instituicao, " (", /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: item.estado
      }, item.estado, ", "), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: item.pais
      }, item.pais), ")"), /*#__PURE__*/_react.default.createElement(CourseSchool, null, item.instituicao), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: item.data_de_conclusao || item.situacao
      }, /*#__PURE__*/_react.default.createElement(CourseDate, null, /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "time"
      }), _reactIntlUniversal.default.get("CURRICULUM.STATUS_CURSOS." + item.situacao), item.situacao !== 'interrompido' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _moment.default)(item.data_de_conclusao).format('MMMM [de] YYYY'), /*#__PURE__*/_react.default.createElement("span", null, " ", item.duracao))))));
    }));
  };

  Courses.defaultProps = {
    courses: []
  };
  var _default = Courses;
  _exports.default = _default;
});